/* eslint-disable react/require-default-props */
import React from 'react';
import { Text } from '../../atoms/Text/Text';
import { useSideDrawerContext } from './SideDrawerContext';
export function SideDrawerSection({ title, children, className = '' }) {
    const { collapsed } = useSideDrawerContext();
    const sectionClasses = ['qmb-ui-side-drawer-section', className].filter(Boolean).join(' ');
    return (React.createElement("div", { className: sectionClasses, role: "group", "aria-label": typeof title === 'string' ? title : undefined },
        title && !collapsed && (React.createElement("div", { className: "qmb-ui-side-drawer-section__title" }, typeof title === 'string' ? (React.createElement(Text, { variant: "xx-small", as: "span" }, title)) : (title))),
        React.createElement("div", { className: "qmb-ui-side-drawer-section__content" }, children)));
}
